<template>
	<v-container fluid class="crm-index d-flex flex-column"
		:style="'height:'+$store.getters['general/availableHeight']+'px;'">
		<div class="d-flex align-center justify-end mb-2 flex-shrink-0">
			<div class="d-flex align-center" style="flex: 1;max-width: 400px;">
				<v-icon color="#524D4D" @click="searchForString">mdi-magnify</v-icon>
				<v-text-field
					v-model="searchInput"
					:loading="loading"
					outlined
					dense
					hide-details
					item-text="name"
					item-value="id"
					return-object
					clearable
					label="Búsqueda"
					class="mb-0 mr-2 custom-height-search custom-height-calendar"
					color="#524D4D"
					@input="sendToSearch"
				></v-text-field>
			</div>
			<DataTablePagination
				:options.sync="options"
				:item-length="budget_prefixes_count"
				:loading-info="loading"
			/>
		</div>
		<div class="table-container flex-grow-1 pb-2">
			<v-data-table
				ref="table"
				:headers="headers"
				:items="budget_prefixes"
				item-key="id"
				:loading="loading"
				:server-items-length="budget_prefixes_count"
				:options.sync="options"
				loading-text="Cargando datos..."
				class="crm-table"
				:class="$vuetify.breakpoint.mobile ? '':'resizable'"
				disable-sort
				hide-default-footer
				@click:row="selectRow"
				:item-class="selectedRowClass"
				:footer-props="{
					itemsPerPageText: 'Filas por página',
					'items-per-page-options': itemsPerPageOptions
				}"
			>
				<template v-slot:item.name="{ item }">
					{{ item.name }} <b>[{{ item.prefix }}]</b>
				</template>
				<template v-slot:item.type="{ item }">
					{{ getType(item.type) }}
				</template>
				<template v-slot:item.actions="{ item }">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								dark
								x-small
								color="success"
								class="mx-1"
								v-bind="attrs"
								v-on="on"
								@click.stop="() => { selectRow(item); restorePrefix(item.id); }"
							>
								<v-icon small dark>mdi-archive-check-outline</v-icon>
							</v-btn>
						</template>
						<span>Restaurar</span>
					</v-tooltip>
				</template>
			</v-data-table>
		</div>
		<!-- <div class="d-flex align-center justify-end mt-2">
			<DataTablePagination
				:options.sync="options"
				:item-length="budget_prefixes_count"
				:loading-info="loading"
			/>
		</div> -->
  </v-container>
</template>

<script>
import _debounce from 'lodash/debounce'
import DataTablePagination from '@/components/Helpers/Components/DataTablePagination'
import { getBudgetPrefixes, updateBudgetPrefix } from '@/helpers/api/budgets'
// import draggable from "vuedraggable"

export default {
	name: 'CompanyPrefixes',
	components: {
		DataTablePagination,
		// draggable
	},
  data() {
    return {
      search: '',
			selectedRowItem: null,
			searchInput: null,
			loading: false,
			budget_prefixes: [],
			budget_prefixes_count: 0,
			itemsPerPageOptions: [10, 25, 50, 100, 200],
      options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: [],
        sortDesc: [],
      },
      headers: [
        { text: 'Prefijos Para Documentos', value: 'name' },
        { text: 'Tipo de Prefijo', value: 'type' },
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
    };
  },
  computed: {
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		prefixes(){
			return this.$store.state.budget.companiesBudgetPrefixes
		},
  },
	watch: {
		selectedCompany(newValue){
			if(newValue){
				this.reloadInfo()
			}
		}
	},
	mounted(){
		const selectedRow = JSON.parse(localStorage.getItem('selected_prefixeslist_row'));
		if (selectedRow) {
			this.selectedRowItem = selectedRow
		}
		if(this.selectedCompany){
			this.reloadInfo()
		}
	},
  methods: {
		getType(type){
			switch (type) {
				case 'report':
					return 'Prefijo para Informe'
				case 'budget':
					return 'Prefijo para Presupuesto'
				case 'contract':
					return 'Prefijo para Contrato'
				default:
					return 'Otro'
			}
		},
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_prefixeslist_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		sendToSearch: _debounce(function() { this.searchForString() }, 800),
		searchForString(){
			this.options = {...this.options, ...{page: 1}}
			this.reloadInfo()
		},
		async reloadInfo(){
			let data = {
				...this.options,
				start: (this.options.page - 1) * this.options.itemsPerPage,
				limit: this.options.itemsPerPage,
				deleted: true
			}
			if(this.searchInput){
				data = {...data, ...{search: this.searchInput}}
			}
      const prefixes = await getBudgetPrefixes(data)
      if (prefixes.code === 200) {
        this.budget_prefixes = prefixes.budget_prefixes
        this.budget_prefixes_count = prefixes.budget_prefixes_count
      }
		},
		async restorePrefix(budget_prefix_id){
      const prefix = await updateBudgetPrefix({budget_prefix_id, restore: true})
      if (prefix.code === 200) {
				this.reloadInfo()
				const data = {
					message: 'El prefijo ha sido restaurado, ya lo puedes utilizar en tus documentos.',
					title: 'Prefijo restaurado',
					created: new Date(),
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3'
				}
				this.$store.dispatch('general/addMessage', data)
      }
			else{
				const data = {
					message: 'Por favor intenta nuevamente.',
					title: 'Error al restaurar',
					created: new Date(),
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.$store.dispatch('general/addMessage', data)
			}
		}
  },
};
</script>

<style scoped>
</style>